import classNames from 'classnames';
import InformationFields from '../InformationFields';
import AdFields from '../AdFields';

function ProgrammaticContent({
  className,
  style,
  flight,
  onChange = () => {},
  onChangeDropdown = () => {},
  onChangeAdvertiser = () => {},
}) {
  return (
    <div
      className={classNames('ProgrammaticContent', className)}
      style={style}
    >
      <InformationFields
        name={flight.name ?? ''}
        dealId={flight.dealId ?? ''}
        opportunityName={flight.opportunityName ?? ''}
        opportunityId={flight.opportunityId ?? ''}
        extReferenceId={flight.extReferenceId ?? ''}
        onChange={onChange}
      />

      <AdFields
        deliverySystem={flight.deliverySystem ?? ''}
        adProvider={flight.adProvider ?? ''}
        advertiserName={flight.advertiserName ?? ''}
        category={flight.category ?? ''}
        agency={flight.agency ?? ''}
        currencyCode={flight.currencyCode ?? ''}
        programmaticBuyer={flight.programmaticBuyer ?? ''}
        onChange={onChange}
        onChangeDropdown={onChangeDropdown}
        onChangeAdvertiser={onChangeAdvertiser}
      />
    </div>
  );
}

export default ProgrammaticContent;
